export default __webpack_public_path__ + "locales/sk/ChangeUserTypeDialog.json?hash=174b7349495e40ddd007fc77ee47a765";